import { Component, OnInit, ElementRef, Input, Renderer } from "@angular/core";
import { DatePipe } from '@angular/common';
import { DialogService } from "../dialog/index";
import { DialogComponent } from "../dialog/dialog.component";
import { environment } from "../../../../environments/environment";
import { ExpiryDetailsStockComponent } from '../../../shared'
export interface ItemsModel {
  title: string;
  Items: any;
  allowDelete: boolean;
}
@Component({
  selector: "app-grid-edit",
  templateUrl: "./grid-edit.component.html",
  styleUrls: ["./grid-edit.component.css"]
})
export class GridEditComponent extends DialogComponent<ItemsModel, boolean>
  implements ItemsModel, OnInit {
  title: string;
  Items: any;
  allowDelete: boolean;
  Qty: number = 0.0;
  Rate: number = 0.0;
  Amount: number = 0.0;
  Discount: number = 0.0;
  systemqty: number = 0.0;
  actualqty: number = 0.0;
  difference: number = 0.0;
  costprice: number = 0.00;
  FOC: number = 0.00;
  ExpiryDate: Date = new Date();
  BatchNo: string = ""
  result: any = { result: false, RtnItem: {} };
  validated: boolean = true;
  ddate = new Date()
  expirydt: any = []
  exp: any = [];
  @Input() onReturn: string;
  isexpiry: boolean = false;

  Cost_Qty: number = 0;
  Cost_OgCost: number = 0;
  Cost_NewCost: number = 0;
  Cost_Difference: number = 0;
  Cost_Total: number = 0;

  constructor(dialogService: DialogService, public datepipe: DatePipe, private _eRef: ElementRef, private _renderer: Renderer) {
    super(dialogService);
  }

  ngOnInit() {
    this.result.result = false;
    // document.getElementById("foucus").focus();
    for (let i of this.Items) {
      this.result.RtnItem[i.Name] = i.Value;
      if (i.exp == "Q") {
        this.Qty = i.Value;
      } else if (i.exp == "R") {
        this.Rate = i.Value;
      } else if (i.exp == "D") {
        this.Discount = i.Value;
      } else if (i.exp == "S") {
        this.systemqty = i.Value;
      } else if (i.exp == "A") {
        this.actualqty = i.Value;
      }
      else if (i.exp == "Amt") {
        this.Amount = i.Value;
      }
      else if (i.exp == "FOC") {
        this.FOC = i.Value;
      }
      else if (i.exp == "EXPD") {
        this.ExpiryDate = i.Value;
        this.isexpiry = true;
      }
      else if (i.exp == "BTNO") {
        this.BatchNo = i.Value;
        this.isexpiry = true;
      }
      else if (i.exp == "expiry") {
        this.expirydt = i.Value;
      }
      else if (i.exp == "Cost_Qty") {
        this.Cost_Qty = i.Value;
      }
      else if (i.exp == "Cost_OgCost") {
        this.Cost_OgCost = i.Value;
      }
      else if (i.exp == "Cost_NewCost") {
        this.Cost_NewCost = i.Value;
      }
      else if (i.exp == "Cost_Difference") {
        this.Cost_Difference = i.Value;
      }
      else if (i.exp == "Cost_Total") {
        this.Cost_Total = i.Value;
      }
      else {
      }
    }
  }

  ok() {
    if (this.isexpiry) {
      this.calculateBatchNoIsEmpty();
    }
    for (let i of this.Items) {
      if (i.exp == "expiry") {
        i.Value = this.expirydt;
        this.result.RtnItem["Expiry"] = this.expirydt;
      }
    }
    this.result.result = true;
    this.close();
  }
  delete() {
    this.result.result = true;
    this.result.delete = true;
    this.close();
  }
  checkchange(i, e) {
    this.result.RtnItem["Active"] = e.target.checked;
  }
  Validation(i, e) {
    if (i.Type == "number") {
      var vl = e.target.value;
      if (i.Min) {
        if (Number(i.Min) > Number(vl)) {
          alert("Not Valid Number")
          e.target.value = i.Min
          this.result.RtnItem[i.Name] = e.target.value

        }
      } else if (i.Max) {
        if (Number(i.Max) < Number(vl)) {
          alert("Not Valid Number")
          e.target.value = i.Max
          this.result.RtnItem[i.Name] = e.target.value
        }
      }
    }
  }
  controlleave(i) {
    // for (let i of this.Items) {
    if (i.exp == "Q") {
      this.Qty = this.result.RtnItem[i.Name];
      this.Amount = this.Qty * this.Rate

    } else if (i.exp == "Qty") {
      this.Qty = this.result.RtnItem[i.Name];
    } else if (i.exp == "R") {
      this.Rate = this.result.RtnItem[i.Name];

      this.Amount = this.Rate * this.Qty
    } else if (i.exp == "D") {
      this.Discount = this.result.RtnItem[i.Name];
    }
    else if (i.exp == "Qty*Rate") {
      i.Value = (this.Amount - this.Discount).toFixed(environment.noofdecimal);
      this.result.RtnItem[i.Name] = (this.Amount - this.Discount).toFixed(environment.noofdecimal);
    }
    else if (i.exp == "S") {
      this.systemqty = this.result.RtnItem[i.Name];
    } else if (i.exp == "A") {
      this.actualqty = this.result.RtnItem[i.Name];
    } else if (i.exp == "DF") {
      i.Value = this.actualqty - this.systemqty;
      this.result.RtnItem[i.Name] = this.actualqty - this.systemqty;
    } else if (i.exp == "C") {
      this.costprice = this.result.RtnItem[i.Name];
    }
    else if (i.exp == "FOC") {
      this.FOC = this.result.RtnItem[i.Name];
    }
    else if (i.exp == "T") {
      i.Value = this.costprice * (this.systemqty - this.actualqty);
      this.result.RtnItem[i.Name] =
        this.costprice * (this.systemqty - this.actualqty);
    }
    else if (i.exp == "Amt") {
      this.Amount = this.result.RtnItem[i.Name]
      this.Rate = this.Amount / this.Qty
    }
    else if (i.exp == "EXPD") {
      this.getBatchNoForExpiry(this.result.RtnItem[i.Name]);
    }
    else if (i.exp == "BTNO" && this.result.RtnItem[i.Name] == "") {
      this.calculateBatchNoIsEmpty();
    }
    else if (i.exp == "expiry") {
      i.Value = this.expirydt
    }
    else if (i.exp == "Cost_Qty") {
      this.Cost_Qty = this.result.RtnItem[i.Name];
    }
    else if (i.exp == "Cost_OgCost") {
      this.Cost_OgCost = this.result.RtnItem[i.Name];
    }
    else if (i.exp == "Cost_NewCost") {
      this.Cost_NewCost = this.result.RtnItem[i.Name];
    }
    else if (i.exp == "Cost_Difference") {
      this.Cost_Difference = this.Cost_NewCost - this.Cost_OgCost;
      i.Value = this.Cost_Difference;
      this.result.RtnItem[i.Name] = this.Cost_Difference;
    }
    else if (i.exp == "Cost_Total") {
      this.Cost_Total = this.Cost_Difference * this.Cost_Qty;
      i.Value = this.Cost_Total;
      this.result.RtnItem[i.Name] = this.Cost_Total;

    }
    // }
  }

  calculateBatchNoIsEmpty() {
    var list = [];
    list = this.Items;
    var expd = ""
    list.forEach(i => {
      if (i.exp == "EXPD") {
        expd = i.Value
      }
      if (i.exp == "BTNO" && this.result.RtnItem[i.Name] == "") {
        var newdate = this.datepipe.transform(new Date(expd), 'yyyy-MM-dd');
        i.Value = newdate.toString().replace(/-/g, "");
        this.result.RtnItem[i.Name] = newdate.toString().replace(/-/g, "");
      }
    });
    this.Items = list;
  }

  getBatchNoForExpiry(expd) {
    var list = [];
    list = this.Items;
    list.forEach(i => {
      if (i.exp == "BTNO") {
        var newdate = this.datepipe.transform(new Date(expd), 'yyyy-MM-dd');
        i.Value = newdate.toString().replace(/-/g, "");
        this.result.RtnItem[i.Name] = newdate.toString().replace(/-/g, "");
      }
    });
    this.Items = list;
  }

  selectchange(i) {
    this.result.RtnItem[i.Name] = i.Value;
  }
  Expiry() {
    const a = JSON.stringify(this.expirydt);
    const b = JSON.parse(a);
    let d = this.dialogService
      .addDialog(ExpiryDetailsStockComponent, {
        title: "Expiry Edit", message: "", data: b
      })
      .subscribe(res => {
        if (res.result) {
          this.expirydt = res.item
        }
      });
  }

  ngAfterViewInit() {
    let formChildren = [].slice.call(this._eRef.nativeElement.children);
    formChildren.every(child => {
      let input = this.getInputElement(child);
      if (input) {
        this._renderer.invokeElementMethod(input, 'focus', []);
        return false;
      }
      return true;
    });
  }

  getInputElement(nativeElement: any): any {
    if (!nativeElement || !nativeElement.children) return undefined;
    if (!nativeElement.children.length && nativeElement.localName === 'input' && !nativeElement.hidden) return nativeElement;

    let input;
    [].slice.call(nativeElement.children).every(c => {
      input = this.getInputElement(c);
      if (input) return false;
      return true;
    });
    return input;
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/component/grid-edit/grid-edit.component.ts